import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  baseUrl = environment.baseUrl;

  myAccountForm = new FormGroup({
    // _id: new FormControl(null),
    fullname: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    // mobile: new FormControl({ value: '', disabled: true }),
    role: new FormControl({ value: '', disabled: true }),
    // profilePhoto: new FormControl(null, Validators.required),

  });

  changePasswordForm = new FormGroup({
    current_password: new FormControl('', [Validators.required]),
    new_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirm_new_password: new FormControl('', [Validators.required, Validators.minLength(6)]),
  });

  constructor(
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
  ) { }

  update_account(formData: any) {
    return this.http.post(this.baseUrl + '/my-account', {
      fullname: formData.fullname,
      email: formData.email,
      // mobile: formData.mobile,
      role: formData.role,
      // profilePhoto: formData.profilePhoto,
    });
  }

  changePassword(formData: any) {
  // console.log('Change Password Data:', formData);
    return this.http.post(this.baseUrl + '/change-password', {
      current_password: formData.current_password,
      new_password: formData.new_password,
      confirm_new_password: formData.confirm_new_password,
    });
  }

  // changePassword(formData: any) {
  //   const token = this.authService.getToken();

  //   return this.http.post(
  //     this.baseUrl + '/change-password',
  //     {
  //       current_password: formData.current_password,
  //       new_password: formData.new_password,
  //       confirm_new_password: formData.confirm_new_password,
  //     },
  //     {
  //       headers: {
  //         Authorization: `Bearer ${token}`
  //       }
  //     }
  //   );
  // }


}

